import React, { useState, useContext } from "react";
import "../../styles/constituencyManagement.css";
import { ToastContainer } from "react-toastify";
import { MdAdd } from "react-icons/md";
import ConstituencyTabs from "./ConstituencyTabs";
import ConstituencyExportForm from "./ConstituencyExportForm";
import ConstituencyContext from "../../context/constituencyContext";
import ConstituencySummary from "./ConstituencySummary";
import AddConstituency from "./AddConstituency";
import EditConstituency from "./EditConstituency";
import DeleteConstituency from "./DeleteConstituency";
import AddApprovalRatingShape from "../ApprovalRating/AddApprovalRatingShape";
import AddBlockShape from "./AddBlockShape";
import AddQuantitativeSurvey from "./AddQuantitativeSurvey";

const Result = () => {
  const constituencyContext = useContext(ConstituencyContext);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showARShape, setShowARShape] = useState(false);
  const [showBlockShape, setShowBlockShape] = useState(false);
  const [showQuantitativeSurvey, setShowQuantitativeSurvey] = useState(false);

  const handleAddModal = () => {
    constituencyContext.updateOpenModal(true);
  };
  const handleEditModal = () => {
    setShowEdit(true);
  };
  const handleDeleteModal = () => {
    setShowDelete(true);
  };
  const handleAddARShapeModal = () => {
    setShowARShape(true);
  };
  const handleBlockShapeModal = () => {
    setShowBlockShape(true);
  };
  const handleQuantitativeSurveyModal = () => {
    setShowQuantitativeSurvey(true);
  };

  return (
    <div className='constituency-section'>
      <ToastContainer />

      <div className='pageTitle flex items-center justify-between pr-5'>
        <div className='heading-sec pl-4'>
          <h1 className='heading-text'>Constituency Management Dashboard</h1>
        </div>
        <div className='flex items-center'>
          <button className='rounded-lg mr-2' onClick={handleAddModal}>
            <MdAdd /> Add New Constituency
          </button>
          <button className='rounded-lg mr-2' onClick={handleEditModal}>
            Edit Constituency
          </button>
          <button className='rounded-lg mr-2' onClick={handleDeleteModal}>
            Delete Constituency
          </button>
          <button className='rounded-lg mr-2' onClick={handleAddARShapeModal}>
            <MdAdd /> Add AR Shape
          </button>
          <button className='rounded-lg mr-2' onClick={handleBlockShapeModal}>
            <MdAdd /> Add Block Shape
          </button>
          <button className='rounded-lg mr-2' onClick={handleQuantitativeSurveyModal}>
            <MdAdd /> Add Quantitative Survey
          </button>
        </div>
      </div>

      <ConstituencySummary />
      <ConstituencyExportForm
        isOpen={constituencyContext.isOpenExportModal}
        isExportMode={constituencyContext.isExportMode}
      />

      <AddConstituency
        isOpen={constituencyContext.isOpenModal}
        isAddMode={constituencyContext.isAddMode}
      />
      <EditConstituency
        isOpen={showEdit}
        setShowEdit={setShowEdit}
        isAddMode={constituencyContext.isAddMode}
      />
      <DeleteConstituency isOpen={showDelete} setShowDelete={setShowDelete} />
      <AddApprovalRatingShape 
        isOpen={showARShape} 
        setShowARShape={setShowARShape}
      />
      <AddBlockShape
        isOpen={showBlockShape}
        setShowBlockShape={setShowBlockShape}
      />
      <AddQuantitativeSurvey
        isOpen={showQuantitativeSurvey}
        setShowQuantitativeSurvey={setShowQuantitativeSurvey}
      />

      <div className='constituency-map'>
        <ConstituencyTabs />
      </div>
    </div>
  );
};

export default Result;
